// Check if a value is negative
export default function (value, options) {
  if (value !== undefined) {
    return options.fn(this);
  }
  return options.inverse(this);
}
